import { CenaAdmin } from "@/features/admin/CenaAdmin";
import { useAppShell } from "@/shell/app-shell-context";

export function CenaAdminRoute() {
  const { token } = useAppShell();
  return <CenaAdmin token={token} />;
}
